import { render, staticRenderFns } from "./cycleChat.vue?vue&type=template&id=68535e0f"
import script from "./cycleChat.vue?vue&type=script&lang=js"
export * from "./cycleChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports